<template>
  <div class="service-visit-page">
    <KTCard ref="preview" v-bind:title="'Add new'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'list-service-visit-comments' }">
            {{ $t("SERVICE_VISIT_COMMENTS.TITLE") }}
          </router-link>
          <i class="mr-2"></i>
          <small class="">{{ $t("LABELS.ADD_NEW") }}</small>
        </h3>
      </template>
      <template v-slot:toolbar>
        <div class="service-visit-page__actions">
          <BackButton></BackButton>
          <SaveButtonDropdown
            :defaultAction="'continue'"
            :isLoading="isLoadingServiceVisitComment"
            v-on:save="onSave($event)"
          ></SaveButtonDropdown>
        </div>
      </template>
      <template v-slot:body>
        <b-form>
          <ServiceVisitCommentsForm
            v-if="!firstLoader"
            ref="ServiceVisitCommentsForm"
            :form="form"
          ></ServiceVisitCommentsForm>

          <v-overlay :value="!firstLoader && isLoadingServiceVisitComment">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </b-form>
      </template>
      <template v-slot:foot>
        <div
          v-show="_.size(errors) > 0"
          role="alert"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error[0] || error }}
          </div>
        </div>
      </template>
      <template v-slot:toolbarfoot>
        <div class="service-visit-page__actions">
          <BackButton></BackButton>
          <SaveButtonDropdown
            :defaultAction="'continue'"
            :isLoading="isLoadingServiceVisitComment"
            v-on:save="onSave($event)"
          ></SaveButtonDropdown>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SAVE_SERVICE_VISIT_COMMENT } from "@/modules/service-visit-comments/store/service-visit-comments.module";
import KTCard from "@/view/content/Card.vue";
import SaveButtonDropdown from "@/view/content/forms/components/SaveButtonDropdown.vue";
import { mapGetters } from "vuex";
import ServiceVisitCommentsForm from "../components/ServiceVisitCommentsForm.vue";

export default {
  name: "ServiceVisitCommentsAdd",
  components: {
    KTCard,
    SaveButtonDropdown,
    ServiceVisitCommentsForm
  },
  data() {
    return {
      errors: {},
      firstLoader: true,
      form: {
        serviceVisitId: null,
        body: ""
      }
    };
  },
  computed: {
    ...mapGetters(["isLoadingServiceVisitComment"])
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.$i18n.t("SERVICE_VISIT_COMMENTS.TITLE"),
        route: { name: "list-service-visit-comments" }
      },
      { title: this.$i18n.t("LABELS.ADD_NEW") }
    ]);

    this.$nextTick(() => {
      this.firstLoader = false;
    });
  },
  methods: {
    onSave(next) {
      const formComponent = this.$refs.ServiceVisitCommentsForm;
      formComponent.$v.form.$touch();

      if (formComponent.$v.form.$anyError) {
        this.$notify({
          group: "notify",
          type: "error",
          title: "<i class='flaticon-close'></i> Warning",
          text: "Please fill all required fields correctly"
        });
        return;
      }

      this.$store
        .dispatch(SAVE_SERVICE_VISIT_COMMENT, this.form)
        .then(data => {
          this.errors = data.data.errors;
          this.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });

          if (next == "continue") {
            this.$router.push({
              name: "edit-service-visit-comments",
              params: { id: data.data.id }
            });
          }
          if (next == "new") {
            this.$router.push({ name: "add-service-visit-comments" });
          }
          if (next == "exit") {
            this.$router.push({ name: "list-service-visit-comments" });
          }
        })
        .catch(response => {
          this.errors = response.data.errors;
          this.$notify({
            group: "notify",
            type: "error",
            title: this.$t("ALERTS.ERROR"),
            text: response.data.message
          });
        });
    }
  }
};
</script>
